import { render, staticRenderFns } from "./ImagePreview.vue?vue&type=template&id=0a354d12&scoped=true&lang=pug&"
import script from "./ImagePreview.vue?vue&type=script&lang=js&"
export * from "./ImagePreview.vue?vue&type=script&lang=js&"
import style0 from "./ImagePreview.vue?vue&type=style&index=0&id=0a354d12&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a354d12",
  null
  
)

component.options.__file = "ImagePreview.vue"
export default component.exports